import { library } from '@fortawesome/fontawesome-svg-core';

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons';

import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons';

import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { faUserHardHat } from '@fortawesome/pro-solid-svg-icons';
import { faUserTie } from '@fortawesome/pro-solid-svg-icons';
import { faCar } from '@fortawesome/pro-solid-svg-icons';
import { faPhone } from '@fortawesome/pro-solid-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { faIdBadge } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import { faUserVisor } from '@fortawesome/pro-solid-svg-icons';
import { faDesktop } from '@fortawesome/pro-solid-svg-icons';
import { faUserCog } from '@fortawesome/pro-solid-svg-icons';

import { faCog } from '@fortawesome/pro-solid-svg-icons';
import { faFileContract } from '@fortawesome/pro-solid-svg-icons';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons';
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { faFileCertificate } from '@fortawesome/pro-solid-svg-icons';

import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import { faTablet } from '@fortawesome/pro-solid-svg-icons';
import { faMobile } from '@fortawesome/pro-solid-svg-icons';
import { faLaptop } from '@fortawesome/pro-solid-svg-icons';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons';

import { faTaxi } from '@fortawesome/pro-solid-svg-icons';
import { faPersonCarry } from '@fortawesome/pro-solid-svg-icons';
import { faUserGraduate } from '@fortawesome/pro-solid-svg-icons';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';

const initFontAwesome = () => {
  library.add(
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowDown,
    faTimesCircle,
    faQuestionCircle,
    faCheckCircle,
    faExclamationCircle,
    faInfoCircle,
    faPlusCircle,
    faUser,
    faUserHardHat,
    faUserTie,
    faCar,
    faPhone,
    faEnvelope,
    faIdBadge,
    faExclamationTriangle,
    faUserVisor,
    faDesktop,
    faUserCog,
    faCog,
    faFileContract,
    faQuestion,
    faBuilding,
    faImage,
    faFileCertificate,
    faUpload,
    faTablet,
    faMobile,
    faLaptop,
    faPlus,
    faTimes,
    faEye,
    faEyeSlash,
    faTaxi,
    faPersonCarry,
    faUserGraduate,
    faUsers
  );
};

export default initFontAwesome;
